module.exports = __webpack_public_path__ + "media/images/plans/kaoawase/schedule-4-ff91469af1b7fb24e64de0669c55dfad.jpg";